import Alternative from "views/pages/dashboards/Alternative.js";
import DeviceForm from "views/pages/hrms/devices/DeviceForm.js";
import ProxyForm from "views/pages/hrms/proxy/ProxyForm.js";
import Dashboard from "views/pages/dashboards/Dashboard.js";
import HUCSDashboard from "views/pages/dashboards/HUCSDashboard.js";
import HRMSDashboard from "views/pages/dashboards/HRMSDashboard.js";
import hrmsIcon from "assets/img/theme/hrms-icon.png";
import hucsIcon from "assets/img/theme/hucs-icon.png";
import hadmIcon from "assets/img/theme/hadm-icon.png";
import Tenants from "views/pages/hrms/tenants/Tenants.js";
import Login from "views/pages/examples/Login.js";
import Intercoms from "views/pages/hrms/devices/Intercoms.js";
import Directories from "views/pages/hrms/directories/Directories.js";
import DirectoriesForm from "views/pages/hrms/directories/DirectoriesForm.js";
import VisitorPasses from "views/pages/hrms/visitorPasses/VisitorPasses.js";
import Profile from "views/pages/profile/Profile.js";
import CompanyProfile from "views/pages/profile/CompanyProfile.js";
import CompanyUsers from "views/pages/profile/CompanyUsers.js";
import CompanyClients from "views/pages/profile/CompanyClients.js";
import CompanySites from "views/pages/profile/CompanySites.js";
import SiteProfile from "views/pages/profile/SiteProfile.js";
import NewSubscription from "views/pages/subscriptions/NewSubscription";
import SubscriptionHistory from "views/pages/subscriptions/SubscriptionHistory";
import ProtectedRoute from "components/ProtectedRoute.js";

import GenericEdit from "views/pages/hucs/GenericEdit";
import GenericAdd from "views/pages/hucs/GenericAdd";
import AccessControlsAddEdit from "views/pages/hucs/advanced/accessControls/AccessControlsAddEdit";
import ExtensionAddEdit from "views/pages/hucs/extensions/extensionAddEdit";
import DeviceAddEdit from "views/pages/hucs/devices/DeviceAddEdit";
import DeviceProfileAddEdit from "views/pages/hucs/devices/DeviceProfileAddEdit";
import SipAddEdit from "views/pages/hucs/advanced/sipProfiles/SipAddEdit";
import DevicesTable from "views/pages/hucs/devices/DeviceTable";
import ExtensionsTable from "views/pages/hucs/extensions/extensionTable";
import DeviceProfileTable from "views/pages/hucs/devices/DeviceProfileTable";
import DeviceVendorTable from "views/pages/hucs/devices/DeviceVendorTable";
import DeviceVendorAddEdit from "views/pages/hucs/devices/DeviceVendorAddEdit";
import EmailTempAddEdit from "views/pages/hucs/advanced/emailTemplates/EmailTempAddEdit";
import NumTranslationAddEdit from "views/pages/hucs/advanced/numberTranslations/NumTranslationAddEdit";
import { DIDBridgeProvider } from "contexts/DIDBridgeContext";
import Dealer from "layouts/Dealer";
import { ExtensionSettings, Gateways } from "views/pages/hucs/configs/Pages/AccountsPages.js";
import {
  Domains,
  DomainSettings,
  DefaultSettings,
  Modules,
  Variables,
  SipProfiles,
  SofiaGlobalSettings,
  AccessControls,
  EmailTemplates,
  Databases,
  NumberTranslations,
} from "views/pages/hucs/configs/Pages/AdvancedPages.js";
import DialplanOutboundAdd from "views/pages/hucs/dialplans/OutboundAdd";
import DestinationAdd from "views/pages/hucs/dialplans/DestinationAdd";
import { Destinations } from "views/pages/hucs/configs/Pages/DialplanPages.js";

import InboundRoutes from "views/pages/hucs/dialplans/InboundTable";
import DialplanInboundAdd from "views/pages/hucs/dialplans/InboundAdd";
import DialplanEdit from "views/pages/hucs/dialplans/DialplanEdit";

import CallblockAddEdit from "views/pages/hucs/applications/callblock/CallblockAddEdit";
import Callblock from "views/pages/hucs/applications/callblock/CallblockTable";

import CallflowAddEdit from "views/pages/hucs/applications/callflow/CallflowAddEdit";
import Callflow from "views/pages/hucs/applications/callflow/CallflowTable";

import IVRAddEdit from "views/pages/hucs/applications/ivr_menu/IVRAddEdit";
import IVRMenu from "views/pages/hucs/applications/ivr_menu/IVRTable";

import Ringgroup from "views/pages/hucs/applications/ring_groups/RinggroupTable";
import RinggroupAddEdit from "views/pages/hucs/applications/ring_groups/RinggroupAdd";

import Timeconditions from "views/pages/hucs/applications/time_conditions/TimeConditionsTable";
import TimeconditionAddEdit from "views/pages/hucs/applications/time_conditions/TimeConditionsAdd";

import CDR from "views/pages/hucs/applications/cdr/CDRTable";
import CDRDetails from "views/pages/hucs/applications/cdr/CDRDetails";
import MusicOnHold from "views/pages/hucs/applications/sound_tables/MusicOnHold";
import Recordings from "views/pages/hucs/applications/sound_tables/Recordings";
import ActiveCalls from "views/pages/status/ActiveCalls";
import Registrations from "views/pages/status/Registrations";
import SIPStatus from "views/pages/status/SIPStatus";
import OutboundTable from "views/pages/hucs/dialplans/OutboundTable";
import ExtensionSummary from "views/pages/status/ExtensionSummary";
import EventGuard from "views/pages/status/EventGuard";
import CDRStatistic from "views/pages/status/CDRStatistics";
import Voicemail from "views/pages/hucs/applications/sound_tables/Voicemails";
import VoicemailDetails from "views/pages/hucs/applications/sound_tables/VoicemailDetails";
import VoicemailAddEdit from "views/pages/hucs/applications/sound_tables/VoicemailAdd";
import SystemStatus from "views/pages/status/SystemStatus";
import DestinationSummary from "views/pages/status/DestinationSummary";
import EmergencyLogs from "views/pages/status/EmergencyLogs";
import EmailQueue from "views/pages/status/EmailQueue";
import EmailQueueView from "views/pages/status/EmailQueueView";
import Bridges from "views/pages/hucs/applications/bridges/BridgesTable";
import BridgesAddEdit from "views/pages/hucs/applications/bridges/BridgesAddEdit";
import DialplanAdd from "views/pages/hucs/dialplans/DialplanAdd";
import DialplanTable from "views/pages/hucs/dialplans/DialplanTable";
import GreetingDetails from "views/pages/hucs/applications/sound_tables/GreetingDetails";
import CallsOverview from "views/pages/dashboards/CallsOverview";
import DealerMenu from "views/pages/dashboards/DealerMenu";
import RegistrationsOverview from "views/pages/dashboards/RegistrationsOverview";
import DialplanPermissionsTable from "views/pages/hucs/dialplans/DialplanPermissionsTable";
import DialplanPermissionsAdd from "views/pages/hucs/dialplans/DialplanPermissionsAdd";
import DIDTable from "views/pages/hucs/dialplans/DIDTable";
import DIDProfile from "views/pages/hucs/dialplans/DIDProfile";

import { PERMISSIONS, RESOURCES } from "utils/permissions";
import DIDImport from "views/pages/hucs/dialplans/DIDImport";
import CallForwardTable from "views/pages/hucs/applications/callforward/CallForwardTable";
import CallForwardAddEdit from "views/pages/hucs/applications/callforward/CallForwardAddEdit";
import SiteSetupWizard from "views/pages/profile/Setup/SiteSetupWizard";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: <Login />,
    layout: "/auth",
  },

  {
    path: "/home",
    name: "Home",
    icon: "fas fa-home",
    miniName: "H",
    component: <Dashboard />,
    layout: "/admin",
  },

  {
    collapse: true,
    name: "HRMS",
    iconType: "image",
    icon: hrmsIcon,
    state: "hrmsCollapse",
    module: true,
    requiredPermissions: ["view"],
    views: [
      {
        path: "/hrms/dashboard",
        name: "Dashboard",
        icon: "fas fa-chart-line",
        component: (
          <ProtectedRoute module="HRMS">
            <HRMSDashboard />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hrms/devices",
        name: "Enterphones",
        icon: "fas fa-tablet-alt",
        miniName: "E",
        component: (
          <ProtectedRoute module="HRMS">
            <Intercoms />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hrms/directories",
        name: "Directories",
        icon: "fas fa-folder-open",
        miniName: "D",
        component: (
          <ProtectedRoute module="HRMS">
            <Directories />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hrms/tenants",
        name: "Tenants",
        icon: "fas fa-user-friends",
        miniName: "U",
        component: (
          <ProtectedRoute module="HRMS">
            <Tenants />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hrms/visitor-passes",
        name: "Visitor Passes",
        icon: "fas fa-qrcode",
        miniName: "VP",
        component: (
          <ProtectedRoute
            module="HRMS"
            allowedRoles={["GLOBAL"]}
            showAccessDenied={false}>
            <VisitorPasses />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hrms/proxy",
        name: "Proxy",
        icon: "fas fa-network-wired",
        allowedRoles: ["GLOBAL"],
        miniName: "P",
        component: (
          <ProtectedRoute
            module="HRMS"
            allowedRoles={["GLOBAL"]}
            showAccessDenied={false}
          >
            <ProxyForm />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
    ],
  },

  {
    collapse: true,
    name: "HUCS",
    iconType: "image",
    icon: hucsIcon,
    state: "hucsCollapse",
    requiredPermissions: ["view"],
    module: true,
    views: [
      {
        path: "/hucs/dashboard",
        name: "Dashboard",
        icon: "fas fa-chart-line",
        component: (
          <ProtectedRoute module="HUCS">
            <HUCSDashboard />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },

      // ACCOUNTS SECTION
      {
        collapse: true,
        name: "Accounts",
        icon: "fas fa-user-friends",
        state: "hucsAccountsCollapse",
        views: [
          {
            collapse: true,
            name: "Devices",
            icon: "fas fa-microchip",
            state: "hucsDevicesCollapse",
            views: [
              {
                path: "/hucs/devices",
                name: "Devices",
                miniName: "DV",
                component: (
                  <ProtectedRoute module="HUCS">
                    <DevicesTable />
                  </ProtectedRoute>
                ),
                layout: "/admin",
              },
              {
                path: "/hucs/deviceProfiles",
                name: "Profiles",
                miniName: "P",
                component: (
                  <ProtectedRoute module="HUCS">
                    <DeviceProfileTable />
                  </ProtectedRoute>
                ),
                layout: "/admin",
              },
              {
                path: "/hucs/deviceVendors",
                name: "Vendors",
                miniName: "V",
                allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
                component: (
                  <ProtectedRoute
                    module="HUCS"
                    allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                    showAccessDenied={false}
                  >
                    <DeviceVendorTable />
                  </ProtectedRoute>
                ),
                layout: "/admin",
              },
            ],
          },
          {
            path: "/hucs/add/device",
            name: "Add Device",
            miniName: "AD",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.CREATE}
              >
                <DeviceAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/device/:device_uuid",
            name: "Edit Device",
            miniName: "ED",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.EDIT}
              >
                <DeviceAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/deviceProfile",
            name: "Add Device Profile",
            miniName: "ADP",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.CREATE}
              >
                <DeviceProfileAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/deviceProfile/:device_profile_uuid",
            name: "Edit Device Profile",
            miniName: "EDP",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.EDIT}
              >
                <DeviceProfileAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/deviceVendor",
            name: "Add Device Vendor",
            miniName: "ADV",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <DeviceVendorAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/deviceVendor/:device_vendor_uuid",
            name: "Edit Device Vendor",
            miniName: "EDV",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DEVICES}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <DeviceVendorAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/extensions",
            name: "Extensions",
            miniName: "Ex",
            component: (
              <ProtectedRoute module="HUCS">
                <ExtensionsTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/extensionSettings",
            name: "Extension Settings",
            miniName: "ExS",
            component: (
              <ProtectedRoute module="HUCS">
                <ExtensionSettings />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/extension",
            name: "Add Extension",
            miniName: "AE",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_EXTENSIONS}
                permission={PERMISSIONS.CREATE}
              >
                <ExtensionAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/extension/:extension_uuid",
            name: "Edit Extension",
            miniName: "EE",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_EXTENSIONS}
                permission={PERMISSIONS.EDIT}
              >
                <ExtensionAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/gateways",
            name: "Gateways",
            miniName: "Gw",
            component: (
              <ProtectedRoute module="HUCS">
                <Gateways />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
        ],
      },
      // DIALPLAN SECTION
      {
        collapse: true,
        name: "Dialplan",
        icon: "fas fa-random",
        state: "hucsDialplanCollapse",
        allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
        views: [
          {
            path: "/hucs/dialplan-permissions",
            name: "Permissions",
            miniName: "Dpp",
            component: (
              <ProtectedRoute module="HUCS">
                <DialplanPermissionsTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/dialplan-routes",
            name: "Dialplans",
            miniName: "Dp",
            component: (
              <ProtectedRoute module="HUCS">
                <DialplanTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/destinations",
            name: "Destinations",
            miniName: "D",
            component: (
              <ProtectedRoute module="HUCS">
                <Destinations />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/inbound-routes",
            name: "Inbound Routes",
            miniName: "IR",
            component: (
              <ProtectedRoute module="HUCS">
                <InboundRoutes />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/outbound-routes",
            name: "Outbound Routes",
            miniName: "OR",
            component: (
              <ProtectedRoute module="HUCS">
                <OutboundTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/add/dialplan-permission",
            name: "Add Dialplan Permission",
            miniName: "AD",
            component: (
              <ProtectedRoute module="HUCS">
                <DialplanPermissionsAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/dialplan-permission/:id",
            name: "Edit Dialplan",
            miniName: "ED",
            component: (
              <ProtectedRoute module="HUCS">
                <DialplanPermissionsAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/dialplan",
            name: "Add Dialplan",
            miniName: "AD",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.CREATE}
              >
                <DialplanAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/dialplan/:id",
            name: "Edit Dialplan",
            miniName: "ED",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.EDIT}
              >
                <DialplanEdit method="dialplan" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/inbound-routes",
            name: "Add Inbound Routes",
            miniName: "AIR",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.CREATE}
              >
                <DialplanInboundAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/inbound-routes/:id",
            name: "EDIT Inbound Routes",
            miniName: "EIR",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.EDIT}
              >
                <DialplanEdit method="inbound" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/outbound-routes",
            name: "Add Outbound Routes",
            miniName: "AOR",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.CREATE}
              >
                <DialplanOutboundAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/outbound-routes/:id",
            name: "EDIT Inbound Routes",
            miniName: "EIR",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.EDIT}
              >
                <DialplanEdit method="outbound" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/destinations",
            name: "Add Destination",
            miniName: " AD",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.CREATE}
              >
                <DestinationAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/destination/:id",
            name: "Edit Destination",
            miniName: "ED",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_DIALPLAN}
                permission={PERMISSIONS.EDIT}
              >
                <DestinationAdd />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
        ],
      },

      // APPLICATIONS SECTION
      {
        collapse: true,
        name: "Applications",
        icon: "fas fa-cogs",
        state: "hucsApplicationsCollapse",
        views: [
          {
            path: "/hucs/bridges",
            name: "Bridges",
            miniName: "B",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <Bridges />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/call-blocks",
            name: "Call Blocks",
            miniName: "CB",
            component: (
              <ProtectedRoute module="HUCS">
                <Callblock />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/call-detail-record",
            name: "Call Detail Record",
            miniName: "CDR",
            component: (
              <ProtectedRoute module="HUCS">
                <CDR />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/call-flows",
            name: "Call Flows",
            miniName: "CF",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <Callflow />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/call-forward",
            name: "Call Forward",
            miniName: "CF",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <CallForwardTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/ivr-menus",
            name: "IVR Menus",
            miniName: "IM",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <IVRMenu />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/music-on-hold",
            name: "Music On Hold",
            miniName: "MOH",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <MusicOnHold />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/recordings",
            name: "Recordings",
            miniName: "IM",
            component: (
              <ProtectedRoute module="HUCS">
                <Recordings />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/ring-groups",
            name: "Ring Groups",
            miniName: "RG",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <Ringgroup />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/time-conditions",
            name: "Time Conditions",
            miniName: "RG",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <Timeconditions />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/voicemails",
            name: "Voicemails",
            miniName: "V",
            component: (
              <ProtectedRoute module="HUCS">
                <Voicemail />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/add/bridge",
            name: "Add Bridges",
            miniName: "AB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <BridgesAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/bridge/:id",
            name: "Edit Bridges",
            miniName: "EB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <BridgesAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/view/call-detail-record/:id",
            name: "Call Detail Record",
            miniName: "CDR",
            component: (
              <ProtectedRoute module="HUCS">
                <CDRDetails />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/call-block",
            name: "Add Call Block",
            miniName: "ACB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
              >
                <CallblockAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/call-block/:id",
            name: "EDIT Call Block",
            miniName: "ECB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
              >
                <CallblockAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/call-flow",
            name: "Add Call Flow",
            miniName: "ACF",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <CallflowAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/call-flow/:id",
            name: "EDIT Call Flow",
            miniName: "ECB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <CallflowAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/call-forward",
            name: "Add Call Forward",
            miniName: "ACF",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <CallForwardAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/call-forward/:id",
            name: "EDIT Call Forward",
            miniName: "ECB",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <CallForwardAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/ivr-menu",
            name: "Add IVR Menu",
            miniName: "AIM",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <IVRAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/ivr-menu/:id",
            name: "Edit IVR Menu",
            miniName: "EIM",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <IVRAddEdit />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/time-condition",
            name: "Add Time Condition",
            miniName: "ATG",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <TimeconditionAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/time-condition/:id",
            name: "Edit Time Condition",
            miniName: "ETC",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <TimeconditionAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/ring-group",
            name: "Add Ring Group",
            miniName: "ARG",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <RinggroupAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/ring-group/:id",
            name: "Edit Ring Group",
            miniName: "ERG",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                showAccessDenied={false}
              >
                <RinggroupAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/view-voicemail/:id",
            name: "Voicemail Detail",
            miniName: "VD",
            component: (
              <ProtectedRoute module="HUCS">
                <VoicemailDetails />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/view-greetings/:id",
            name: "Voicemail Detail",
            miniName: "VD",
            component: (
              <ProtectedRoute module="HUCS">
                <GreetingDetails />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/add/voicemail/",
            name: "Voicemail Detail",
            miniName: "VD",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.CREATE}
              >
                <VoicemailAddEdit method="add" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/edit/voicemail/:id",
            name: "Voicemail Detail",
            miniName: "VD",
            component: (
              <ProtectedRoute
                module="HUCS"
                resource={RESOURCES.HUCS_APPLICATIONS}
                permission={PERMISSIONS.EDIT}
              >
                <VoicemailAddEdit method="edit" />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
        ],
      },

      // STATUS SECTION
      {
        collapse: true,
        name: "Status",
        icon: "fas fa-signal",
        state: "hucsStatusCollapse",
        views: [
          {
            path: "/hucs/active-calls",
            name: "Active Calls",
            miniName: "AC",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <ActiveCalls />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/cdr-statistics",
            name: "CDR Statistics",
            miniName: "CDRS",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <CDRStatistic />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/destination-summary",
            name: "Dest Summary",
            miniName: "DS",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <DestinationSummary />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/email-queue",
            name: "Email Queue",
            miniName: "EQ",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <EmailQueue />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/view-email/:id",
            name: "Email Queue",
            miniName: "EQ",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <EmailQueueView />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/emergency-logs",
            name: "Emergency Logs",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            miniName: "EL",
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <EmergencyLogs />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/event-guard",
            name: "Event Guard",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            miniName: "EG",
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <EventGuard />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/extensions-summary",
            name: "Ext Summary",
            miniName: "ES",
            component: (
              <ProtectedRoute module="HUCS">
                <ExtensionSummary />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/registrations",
            name: "Registrations",
            allowedRoles: ["GLOBAL", "SUPERADMIN", "ADMIN"],
            miniName: "R",
            component: (
              <ProtectedRoute
                allowedRoles={["GLOBAL", "SUPERADMIN", "ADMIN"]}
                module="HUCS"
              >
                <Registrations />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/sips-status",
            name: "SIP Status",
            miniName: "SIPS",
            allowedRoles: ["GLOBAL"],
            component: (
              <ProtectedRoute allowedRoles={["GLOBAL"]} module="HUCS">
                <SIPStatus />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/system-status",
            name: "System Status",
            miniName: "SS",
            allowedRoles: ["GLOBAL"],
            component: (
              <ProtectedRoute allowedRoles={["GLOBAL"]} module="HUCS">
                <SystemStatus />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
        ],
      },
      {
        collapse: true,
        name: "DID",
        icon: "fas fa-random",
        state: "hucsDIDCollapse",
        allowedRoles: ['GLOBAL'],
        views: [
          {
            path: "/hucs/dids",
            name: "DIDs",
            miniName: "DI",
            allowedRoles: ['GLOBAL'],
            component: (
              <ProtectedRoute allowedRoles={['GLOBAL']} module="HUCS">
                <DIDTable />
              </ProtectedRoute>
            ),
            layout: "/admin",
          },
          {
            path: "/hucs/view/did-profile/:id",
            name: "DID Profile",
            miniName: "DP",
            component: (
              <ProtectedRoute module="HUCS">
                <DIDProfile />
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          },
          {
            path: "/hucs/import-did",
            name: "Import DID",
            miniName: "ID",
            component: (
              <ProtectedRoute module="HUCS">
                <DIDBridgeProvider>
                  <DIDImport />
                </DIDBridgeProvider>
              </ProtectedRoute>
            ),
            layout: "/admin",
            invisible: true,
          }
        ]
      },
      // ADVANCED SECTION
      {
        path: "/hucs/access-controls",
        name: "Access Controls",
        miniName: "AC",
        component: (
          <ProtectedRoute module="HUCS">
            <AccessControls />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/add/access-control",
        name: "Add Access Control",
        miniName: "AAC",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.CREATE}
          >
            <AccessControlsAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/edit/access-control/:access_control_uuid",
        name: "Edit Access Control",
        miniName: "EAC",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.EDIT}
          >
            <AccessControlsAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/databases",
        name: "Databases",
        miniName: "DB",
        component: (
          <ProtectedRoute module="HUCS">
            <Databases />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/default-settings",
        name: "Default Settings",
        miniName: "DFS",
        component: (
          <ProtectedRoute module="HUCS">
            <DefaultSettings />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/domains",
        name: "Domains",
        miniName: "D",
        component: (
          <ProtectedRoute module="HUCS">
            <Domains />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/domain-settings",
        name: "Domain Settings",
        miniName: "DS",
        component: (
          <ProtectedRoute module="HUCS">
            <DomainSettings />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/email-templates",
        name: "Email Templates",
        miniName: "ET",
        component: (
          <ProtectedRoute module="HUCS">
            <EmailTemplates />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/add/email-template",
        name: "Add Email Template",
        miniName: "AET",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.CREATE}
          >
            <EmailTempAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/edit/email-template/:email_template_uuid",
        name: "Edit Email Template",
        miniName: "EET",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.EDIT}
          >
            <EmailTempAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/modules",
        name: "Modules",
        miniName: "M",
        component: (
          <ProtectedRoute module="HUCS">
            <Modules />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/number-translations",
        name: "Num Translations",
        miniName: "NT",
        component: (
          <ProtectedRoute module="HUCS">
            <NumberTranslations />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/add/number-translation",
        name: "Add Number Translation",
        miniName: "ANT",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.CREATE}
          >
            <NumTranslationAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/edit/number-translation/:number_translation_uuid",
        name: "Edit Number Translation",
        miniName: "ENT",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.EDIT}
          >
            <NumTranslationAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/sip-profiles",
        name: "SIP Profiles",
        miniName: "SP",
        component: (
          <ProtectedRoute module="HUCS">
            <SipProfiles />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/add/sip-profile",
        name: "Add SIP Profile",
        miniName: "ASP",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.CREATE}
          >
            <SipAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/edit/sip-profile/:sip_profile_uuid",
        name: "Edit SIP Profile",
        miniName: "ESP",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.EDIT}
          >
            <SipAddEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/sofia-global-settings",
        name: "Sofia Global Settings",
        miniName: "SGS",
        component: (
          <ProtectedRoute module="HUCS">
            <SofiaGlobalSettings />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/variables",
        name: "Variables",
        miniName: "V",
        component: (
          <ProtectedRoute module="HUCS">
            <Variables />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/hucs/edit/:table/:id",
        name: "Edit Table",
        miniName: "ET",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.EDIT}
          >
            <GenericEdit />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
      {
        path: "/hucs/add/:table",
        name: "Add Record",
        miniName: "AR",
        component: (
          <ProtectedRoute
            module="HUCS"
            resource={RESOURCES.HUCS_ADVANCED}
            permission={PERMISSIONS.CREATE}
          >
            <GenericAdd />
          </ProtectedRoute>
        ),
        layout: "/admin",
        invisible: true,
      },
    ],
  },

  /*{
    collapse: true,
    name: "MDM",
    iconType: "image",
    icon: hadmIcon,
    state: "mdmCollapse",
    requiredPermissions: ["view"],
    module: true,
    views: [
      {
        path: "/mdm/dashboard",
        name: "Dashboard",
        miniName: "D",
        component: (
          <ProtectedRoute module="HADM">
            <MDMDashboard />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/devices",
        name: "Device Management",
        miniName: "DM",
        component: (
          <ProtectedRoute module="HADM">
            <DeviceManagement />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/remote-control",
        name: "Remote Control",
        miniName: "RC",
        component: (
          <ProtectedRoute module="HADM">
            <RemoteControl />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/locations",
        name: "Device Locations",
        miniName: "DL",
        component: (
          <ProtectedRoute module="HADM">
            <DeviceLocations />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/audit",
        name: "Audit Logs",
        miniName: "AL",
        component: (
          <ProtectedRoute module="HADM">
            <AuditLogs />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/test",
        name: "API Test",
        miniName: "T",
        component: (
          <ProtectedRoute module="HADM">
            <MDMTest />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
      {
        path: "/mdm/proxy-test",
        name: "Proxy Test",
        miniName: "PT",
        component: (
          <ProtectedRoute module="HADM">
            <MDMProxyTest />
          </ProtectedRoute>
        ),
        layout: "/admin",
      },
    ],
  },*/

  {
    path: "/dealer-menu",
    name: "Dealer Menu",
    icon: "ni ni-shop text-success",
    component: (
      <ProtectedRoute module="GLOBAL">
        <DealerMenu />
      </ProtectedRoute>
    ),
    layout: "/admin",
  },
  {
    path: "/calls-overview",
    name: "Calls Overview",
    icon: "ni ni-shop text-success",
    component: (
      <ProtectedRoute module="GLOBAL">
        <CallsOverview />
      </ProtectedRoute>
    ),
    layout: "/admin",
  },
  {
    path: "/registrations-overview",
    name: "Registrations Overview",
    icon: "ni ni-shop text-success",
    component: (
      <ProtectedRoute module="GLOBAL">
        <RegistrationsOverview />
      </ProtectedRoute>
    ),
    layout: "/admin",
  },
  {
    path: "/subscription",
    name: "NewSubscription",
    icon: "ni ni-credit-card text-info",
    allowedRoles: ["GLOBAL"],
    component: (
      <ProtectedRoute
        allowedRoles={["GLOBAL"]}
        showAccessDenied={false}
      >
        <DIDBridgeProvider>
          <NewSubscription />
        </DIDBridgeProvider>
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/subscription/history",
    name: "Subscription History",
    allowedRoles: ["GLOBAL"],
    component: (
      <ProtectedRoute
        allowedRoles={["GLOBAL"]}
        showAccessDenied={false}
      >
        <DIDBridgeProvider>
          <SubscriptionHistory />
        </DIDBridgeProvider>
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
  // Profile related routes
  {
    path: "/profile",
    name: "Profile",
    component: <Profile />,
    layout: "/admin",
  },
  {
    path: "/companyprofile",
    name: "Company Profile",
    component: <CompanyProfile />,
    layout: "/admin",
  },
  {
    path: "/companyusers",
    name: "Company Users",
    component: <CompanyUsers />,
    layout: "/admin",
  },
  {
    path: "/companyclients",
    name: "Company Clients",
    component: <CompanyClients />,
    layout: "/admin",
  },
  {
    path: "/companysites",
    name: "Company Sites",
    component: <CompanySites />,
    layout: "/admin",
  },
  {
    path: "/siteprofile",
    name: "Site Profile",
    component: <SiteProfile />,
    layout: "/admin",
  },
  {
    path: "/site-wizard",
    name: "Site Setup Wizard",
    component: <SiteSetupWizard />,
    layout: "/admin",
  },
  {
    path: "/hrms/add/device",
    name: "Add Device",
    component: (
      <ProtectedRoute
        module="HRMS"
        resource={RESOURCES.HRMS_INTERCOMS}
        permission={PERMISSIONS.CREATE}
      >
        <DeviceForm />
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/hrms/edit/device/:device_uuid",
    name: "Edit Device",
    component: (
      <ProtectedRoute
        module="HRMS"
        resource={RESOURCES.HRMS_INTERCOMS}
        permission={PERMISSIONS.EDIT}
      >
        <DeviceForm />
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/hrms/add/directory",
    name: "Add Directory",
    component: (
      <ProtectedRoute
        module="HRMS"
        resource={RESOURCES.HRMS_DIRECTORIES}
        permission={PERMISSIONS.CREATE}
      >
        <DirectoriesForm />
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/hrms/edit/directory/:directory_uuid",
    name: "Edit Directory",
    component: (
      <ProtectedRoute
        module="HRMS"
        resource={RESOURCES.HRMS_DIRECTORIES}
        permission={PERMISSIONS.EDIT}
      >
        <DirectoriesForm />
      </ProtectedRoute>
    ),
    layout: "/admin",
    invisible: true,
  },
];

export default routes;